<template>
    <div class="talent-level-container">
        <div class="box">
            <div class="control">
                <label class="label inline-block r-top">时间</label>
                <span class="inline-block">
                    <el-date-picker
                            v-model="search.startDate"
                            type="datetime"
                            placeholder="开始时间"
                            size="small"
                            align="right">
                    </el-date-picker>
                    <span class="r-top">~</span>
                    <el-date-picker
                            v-model="search.endDate"
                            type="datetime"
                            placeholder="结束时间"
                            size="small"
                            align="right">
                    </el-date-picker>
                  </span>
                <el-button type="primary" size="small" @click="doSearch">搜索</el-button>
            </div>
        </div>
        <div class="list-wrap">
            <div class="clearfix" v-if="count>0">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <table class="table is-bordered">
                        <thead>
                        <tr>
                            <th>日期</th>
                            <th>促销计划的下单用户数</th>
                            <th>订单数</th>
                            <th>销量</th>
                            <th>gmv</th>
                            <th>折扣金额</th>
                            <th>促销计划中的总商品数</th>
                            <th>pv</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in list">
                            <td>{{item.date}}</td>
                            <td>{{item.userCount}}</td>
                            <td>{{item.orderCount}}</td>
                            <td>{{item.soldCount}}</td>
                            <td>{{item.gmv}}</td>
                            <td>{{item.discountPrice}}</td>
                            <td>{{item.goodsCount}}</td>
                            <td>{{item.pv}}</td>
                        </tr>
                        </tbody>
                    </table>
                </article>
            </div>
            <div class="clearfix" v-if="count>0">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>

    </div>
</template>
<script type="text/babel">
    import { getQueryString } from 'UTILS/url'
    import { getTimeByDateStr } from 'UTILS/date'

    export default {
        data(){
            return {
                search: {
                    page: 1,
                    pageSize: 20,
                    promotionId:null,
                    startDate:null,
                    endDate:null,
                },
                list: [],
                count: 0,
            }
        },
        mounted(){
            this.search.promotionId=getQueryString("promotionId",window.location.href)
            this.getList()
        },
        methods: {
            doSearch(){
                this.search.page = 1;
                this.getList();
            },
            handleCurrentChange(value) {
                if(this.search.page !== value){
                    this.search.page = value
                    this.getList()
                }
            },
            getList(){
                let params = Object.assign({}, this.search, {startDate: getTimeByDateStr(this.search.startDate), endDate: getTimeByDateStr(this.search.endDate),})
                HttpRequest.get('/admin.php?method=promotion.getStatistics', params).then(response => {
                    this.list = _.toArray(response.data.list)
                    this.count = response.data.count
                })
            },
        },

    }
</script>
<style lang="less" scoped>
    td {
        text-align: center;
    }
</style>
